module.exports = [
	{
		"fund_family_label": "Vanguard",
		"as_of": "202504",
		"fund_id": 186,
		"net_asset_sum": 9647752344320,
		"long_asset_sum": 9812876652174,
		"num_equity_funds": 103,
		"equity_fund_net_assets": 7011903280027,
		"equity_fund_long_assets": 7013713520479,
		"num_e_sri": 6,
		"num_e_usf": 0,
		"sri_long_assets": 39533795477,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 38714367492,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"t_count_sum": 149,
		"t_asset_sum": 34700231717,
		"t_m_count_sum": 158,
		"t_m_asset_sum": 55539804581,
		"t_all_count_sum": 307,
		"t_all_asset_sum": 90240036298,
		"t_all_weight_total": 0.012866227859822407,
		"name": "Vanguard",
		"fund_family_name": "Vanguard",
		"label": "Vanguard"
	},
	{
		"fund_family_label": "BlackRock/iShares",
		"as_of": "202504",
		"fund_id": 599,
		"net_asset_sum": 3671465179458,
		"long_asset_sum": 3897415182946,
		"num_equity_funds": 314,
		"equity_fund_net_assets": 2483438621625,
		"equity_fund_long_assets": 2498281455711,
		"num_e_sri": 38,
		"num_e_usf": 0,
		"sri_long_assets": 58774322678,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 48731644806,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"t_count_sum": 249,
		"t_asset_sum": 14245265000,
		"t_m_count_sum": 235,
		"t_m_asset_sum": 18741883516,
		"t_all_count_sum": 484,
		"t_all_asset_sum": 32987148516,
		"t_all_weight_total": 0.01320393602593988,
		"name": "BlackRock/iShares",
		"fund_family_name": "BlackRock/iShares",
		"label": "BlackRock/iShares"
	},
	{
		"fund_family_label": "American Funds/Capital Group",
		"as_of": "202504",
		"fund_id": 95,
		"net_asset_sum": 2830778281503,
		"long_asset_sum": 2840990811942,
		"num_equity_funds": 35,
		"equity_fund_net_assets": 2104804825452,
		"equity_fund_long_assets": 2108233696915,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"t_count_sum": 93,
		"t_asset_sum": 48719871965,
		"t_m_count_sum": 29,
		"t_m_asset_sum": 10603596801,
		"t_all_count_sum": 122,
		"t_all_asset_sum": 59323468766,
		"t_all_weight_total": 0.028138943444841358,
		"name": "American Funds/Capital Group",
		"fund_family_name": "American Funds/Capital Group",
		"label": "American Funds/Capital Group"
	},
	{
		"fund_family_label": "Fidelity Investments",
		"as_of": "202504",
		"fund_id": 546,
		"net_asset_sum": 3931832663313,
		"long_asset_sum": 4007479229896,
		"num_equity_funds": 305,
		"equity_fund_net_assets": 2668237275935,
		"equity_fund_long_assets": 2679893054448,
		"num_e_sri": 21,
		"num_e_usf": 0,
		"sri_long_assets": 8247782105,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 7209733505,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"t_count_sum": 259,
		"t_asset_sum": 11436240808,
		"t_m_count_sum": 283,
		"t_m_asset_sum": 17226212105,
		"t_all_count_sum": 542,
		"t_all_asset_sum": 28662452913,
		"t_all_weight_total": 0.010695371916213964,
		"name": "Fidelity Investments",
		"fund_family_name": "Fidelity Investments",
		"label": "Fidelity Investments"
	},
	{
		"fund_family_label": "State Street",
		"as_of": "202504",
		"fund_id": 191,
		"net_asset_sum": 1556452674765,
		"long_asset_sum": 1556850117249,
		"num_equity_funds": 107,
		"equity_fund_net_assets": 1250049521557,
		"equity_fund_long_assets": 1250051252209,
		"num_e_sri": 6,
		"num_e_usf": 0,
		"sri_long_assets": 2147073258,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 2105946916,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"t_count_sum": 134,
		"t_asset_sum": 7573672636,
		"t_m_count_sum": 96,
		"t_m_asset_sum": 12004652384,
		"t_all_count_sum": 230,
		"t_all_asset_sum": 19578325020,
		"t_all_weight_total": 0.015662017845590414,
		"name": "State Street",
		"fund_family_name": "State Street",
		"label": "State Street"
	},
	{
		"fund_family_label": "Schwab Funds",
		"as_of": "202504",
		"fund_id": 94,
		"net_asset_sum": 630638407236,
		"long_asset_sum": 630772726103,
		"num_equity_funds": 43,
		"equity_fund_net_assets": 549455443635,
		"equity_fund_long_assets": 549475341866,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 25878101,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 25878101,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"t_count_sum": 72,
		"t_asset_sum": 5503845130,
		"t_m_count_sum": 69,
		"t_m_asset_sum": 4136972439,
		"t_all_count_sum": 141,
		"t_all_asset_sum": 9640817569,
		"t_all_weight_total": 0.01754549628425564,
		"name": "Schwab Funds",
		"fund_family_name": "Schwab Funds",
		"label": "Schwab Funds"
	},
	{
		"fund_family_label": "T. Rowe Price",
		"as_of": "202504",
		"fund_id": 174,
		"net_asset_sum": 931684621075,
		"long_asset_sum": 936781693163,
		"num_equity_funds": 77,
		"equity_fund_net_assets": 624564668458,
		"equity_fund_long_assets": 625608414117,
		"num_e_sri": 1,
		"num_e_usf": 0,
		"sri_long_assets": 23705680,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 23705680,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"t_count_sum": 33,
		"t_asset_sum": 1252638326,
		"t_m_count_sum": 56,
		"t_m_asset_sum": 2155786964,
		"t_all_count_sum": 89,
		"t_all_asset_sum": 3408425290,
		"t_all_weight_total": 0.005448176867650894,
		"name": "T. Rowe Price",
		"fund_family_name": "T. Rowe Price",
		"label": "T. Rowe Price"
	},
	{
		"fund_family_label": "Thrift Savings Plan",
		"as_of": "202504",
		"fund_id": 14,
		"net_asset_sum": 755500000039,
		"long_asset_sum": 757832553640,
		"num_equity_funds": 3,
		"equity_fund_net_assets": 517100000012,
		"equity_fund_long_assets": 518776815174,
		"num_e_sri": 0,
		"num_e_usf": 0,
		"sri_long_assets": 0,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 0,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"t_count_sum": 9,
		"t_asset_sum": 3172127793,
		"t_m_count_sum": 8,
		"t_m_asset_sum": 4499780429,
		"t_all_count_sum": 17,
		"t_all_asset_sum": 7671908222,
		"t_all_weight_total": 0.014788456225490356,
		"name": "Thrift Savings Plan",
		"fund_family_name": "Thrift Savings Plan",
		"label": "Thrift Savings Plan"
	},
	{
		"fund_family_label": "TIAA Investments/Nuveen",
		"as_of": "202504",
		"fund_id": 165,
		"net_asset_sum": 685423802061,
		"long_asset_sum": 686251325012,
		"num_equity_funds": 62,
		"equity_fund_net_assets": 446932544290,
		"equity_fund_long_assets": 446956470956,
		"num_e_sri": 15,
		"num_e_usf": 1,
		"sri_long_assets": 44237494489,
		"usf_long_assets": 13791506071,
		"equity_fund_sri_long_assets": 36714570658,
		"equity_fund_usf_long_assets": 7062666990,
		"sustainable_manager": 0,
		"t_count_sum": 53,
		"t_asset_sum": 1738543804,
		"t_m_count_sum": 71,
		"t_m_asset_sum": 3845329854,
		"t_all_count_sum": 124,
		"t_all_asset_sum": 5583873658,
		"t_all_weight_total": 0.012493103961682427,
		"name": "TIAA Investments/Nuveen",
		"fund_family_name": "TIAA Investments/Nuveen",
		"label": "TIAA Investments/Nuveen"
	},
	{
		"fund_family_label": "Invesco",
		"as_of": "202504",
		"fund_id": 327,
		"net_asset_sum": 967057187287,
		"long_asset_sum": 986685546990,
		"num_equity_funds": 198,
		"equity_fund_net_assets": 732559791309,
		"equity_fund_long_assets": 735447184083,
		"num_e_sri": 14,
		"num_e_usf": 0,
		"sri_long_assets": 9471245717,
		"usf_long_assets": 0,
		"equity_fund_sri_long_assets": 6718099287,
		"equity_fund_usf_long_assets": 0,
		"sustainable_manager": 0,
		"t_count_sum": 91,
		"t_asset_sum": 2848576337,
		"t_m_count_sum": 107,
		"t_m_asset_sum": 6446088927,
		"t_all_count_sum": 198,
		"t_all_asset_sum": 9294665264,
		"t_all_weight_total": 0.012638113878414193,
		"name": "Invesco",
		"fund_family_name": "Invesco",
		"label": "Invesco"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/FamilyFunds.json
// module id = 917
// module chunks = 0